<template>
    <div class="position-relative">
        <tourn-table :columns="columns" :data="comparison" :settings="tableSettings">
            <template v-slot:th="{ item }">
                {{ 'admin.revenue.comparison.' + item | lang }}
            </template>
            <template v-slot:td-status="{ item }">
                <div v-if="item.status === 'error'" class="text-danger">
                    <span class="fas fa-bug fa-lg fa-fw"></span>
                    <div class="mt-1"><em>{{item.message}}</em></div>
                </div>
                <div v-else-if="item.status === 'valid'" class="text-success">
                    <span class="fas fa-check fa-lg fa-fw"></span>
                    <div class="mt-1 font-weight-bold">{{ item.diff === 0 ? 'Correct' : 'Acceptable' }}</div>
                </div>
                <div v-else class="text-danger">
                    <span class="fas fa-times fa-lg fa-fw"></span>
                    <div class="mt-1 font-weight-bold">Incorrect</div>
                </div>
            </template>
            <template v-slot:td-actual="{ item }">
                <em v-if="item.actual === null">Unknown</em>
                <span v-else>{{item.actual}}</span>
            </template>
            <template v-slot:td-estimated="{ item }">
                <em v-if="item.estimated === null">Unknown</em>
                <span v-else>{{item.estimated}}</span>
            </template>
            <template v-slot:td-diff="{ item }">
                <em v-if="item.diff === null">Unknown</em>
                <strong v-else-if="item.diff !== 0" :class="Math.abs(item.diff) <= item.cutoff ? 'text-primary' : 'text-danger'">
                    {{item.diff}}
                    <span class="fas fa-fw ml-1"
                          :class="item.diff > 0 ? 'fa-arrow-up' : 'fa-arrow-down'"></span>
                </strong>
                <strong v-else class="text-success">
                    {{item.diff}}
                </strong>
            </template>
        </tourn-table>
        <t-loader :locked="loading"></t-loader>
    </div>
</template>

<script>
  import axios from 'axios';
  import TournTable from "#/js/components/TTable";
  import TournError from "#/js/components/TError";

  export default {
    name: "RevenueUpdateValidation",
    components: {TournError, TournTable},
    props: {
      id: Number,
    },
    data() {
      return {
        comparison: [],
        columns: ['status', 'type', 'name', 'actual', 'estimated', 'diff'],
        tableSettings: {
          type: {class: ['text-capitalize', 'font-weight-bold']},
          actual: {class: 'text-right'},
          estimated: {class: 'text-right'},
          diff: {class: 'text-right'},
          status: {tdClass: 'text-center'},
        },
        loading: true,
      }
    },
    mounted() {
      Echo.private(this.channel)
        .listen('MonthlyRevenueValidation', (data) => {
          this.comparison = data.comparison;
          this.loading = false;
        });

      this.getComparison();
    },
    beforeDestroy() {
      Echo.private(this.channel).stopListening('MonthlyRevenueValidation');
    },
    computed: {
      channel() {
        return `revenueUpdate.${this.id}`;
      },
      route() {
        return `/admin/revenue/updates/${this.id}/compare`;
      }
    },
    methods: {
      getComparison() {
        axios.post(this.route).then((response) => {
          console.log('sent request for comparison');
        })
      }
    }
  }
</script>

<style scoped>

</style>